/**
 * Plant-type icons: `/public/img/<name>.webp`.
 * When you add a new `.webp` here, append its basename to `PLANT_ICON_NAMES` (picker order).
 */
export const PLANT_ICON_NAMES: readonly string[] = [
  'mixed-berry',
  'red-berry',
  'blue-berry',
  'yellow-berry',
  'green-berry',
  'white-berry',
  'hemp',
  'potato',
  'pumpkin',
  'corn',
  'wheat',
  'orchid',
  'rose',
  'sunflower'
];

export function plantImageUrl(name: string): string {
  const base =
    typeof process !== 'undefined' && process.env && typeof process.env.BASE_URL === 'string'
      ? process.env.BASE_URL
      : '/';
  const root = base.endsWith('/') ? base : `${base}/`;
  return `${root}img/${name}.webp`;
}

/** URL for a saved-set row; falls back if the stored name is missing or unknown. */
export function plantImageUrlForStoredType(plantTypeName: string | undefined | null): string {
  const n = plantTypeName || 'mixed-berry';
  const safe = (PLANT_ICON_NAMES as readonly string[]).includes(n) ? n : 'mixed-berry';
  return plantImageUrl(safe);
}
